import { NgModule }                 from "@angular/core";
import { CommonModule }             from "@angular/common";
import { FormsModule }              from "@angular/forms";
import { PaginationModule }         from "ng2-bootstrap/components/pagination";
import { NgbModule }                from "@ng-bootstrap/ng-bootstrap";
import { AccountWorkflowComponent } from "./account";
import { OrganisationWorkflowComponent } from "./organisation";
import { ApplicationAccessWorkflowComponent } from "./applicationAccess";
import { WORKFLOWROUTING }          from "./workflow.route";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PaginationModule,
    NgbModule,
    WORKFLOWROUTING
  ],
  declarations: [
    AccountWorkflowComponent,
    OrganisationWorkflowComponent,
    ApplicationAccessWorkflowComponent
  ],
  providers: [ ]
})

export class WorkflowModule { }



// WEBPACK FOOTER //
// ./src/app/modules/workflow/workflow.module.ts